import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import ViewCompactIcon from '@mui/icons-material/ViewCompact';
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
import SegmentedToggle from './SegmentedToggle';

interface FeedViewBarProps {
  viewMode: string;
  handleViewChange: (value: string) => void;
}

/**
 * The feed's view toggle (expanded / compact cards).
 *
 * This used to be SortTabBar, with a Hot/Best/Top/… dropdown beside it. The
 * feed is personalized server-side now (joined herds + preference
 * topics) and the manual sorts ranked on frozen vote data, so the dropdown is
 * gone — how the cards LOOK is the one choice that stayed the reader's.
 */
const FeedViewBar: FC<FeedViewBarProps> = ({ viewMode, handleViewChange }) => {
  return (
    <Box
      sx={{
        borderRadius: 'var(--radius-none)',
        marginBottom: 'var(--space-stack-compact)',
        p: 1,
        display: 'flex',
        justifyContent: 'flex-end',
        '@media (max-width:600px)': { marginBottom: 'none' },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography
          variant="caption"
          sx={{
            ml: 1,
            mb: 0.5,
            display: 'block',
            fontFamily: 'var(--font-mono)',
            fontSize: '10.5px',
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            color: 'var(--color-text-4)',
          }}
        >
          View
        </Typography>
        <SegmentedToggle
          value={viewMode}
          onChange={handleViewChange}
          ariaLabel="Feed view"
          iconOnly
          options={[
            { value: 'expanded', label: 'Expanded', icon: <ViewAgendaIcon /> },
            { value: 'compact', label: 'Compact', icon: <ViewCompactIcon /> },
          ]}
        />
      </Box>
    </Box>
  );
};

export default FeedViewBar;
